import type { Glossary } from "@/glossary/types";

export const formatScore = (score: number) =>
  parseFloat((score / 100).toFixed(2));

export const getScoreFeedback = (
  score: number,
  maxScore: number,
  t: Glossary,
) => {
  const displayScore = formatScore(score);
  const displayMax = formatScore(maxScore);
  const percentage = maxScore > 0 ? (score / maxScore) * 100 : 0;

  if (percentage >= 90) {
    return t.common.scoreFeedbackFantastic(displayScore, displayMax);
  }
  if (percentage >= 75) {
    return t.common.scoreFeedbackGreat(displayScore, displayMax);
  }
  if (percentage >= 60) {
    return t.common.scoreFeedbackWellDone(displayScore, displayMax);
  }
  return t.common.scoreFeedbackCanDoBetter(displayScore, displayMax);
};
